import { Course, LocationModel } from '../../../models';

export const getCourses = (): Course[] => {
  return [
    {
      id: 0,
      lmsCourseId: 123123,
      name: 'Some course',
    },
    {
      id: 1,
      lmsCourseId: 12312,
      name: 'Some other course',
    },
  ];
};

export function getLocationsMock(count = 12): LocationModel[] {
  const locationsMock: LocationModel[] = [];

  for (let i = 1; i <= count; i++) {
    locationsMock.push({
      id: i,
      name: `Location ${i}`,
    });
  }

  return locationsMock;
}
